import {Spinner} from '@chakra-ui/react';

export default function ChakraSpinner({...rest}) {
    return <Spinner {...rest} />;
}
